import {
  CardCVCElement,
  CardElement,
  CardExpiryElement,
  CardNumberElement,
  Elements,
  IdealBankElement
} from 'react-stripe-elements';

import { StripeComponentInputType } from '../types';
import { withUIComponentsStyles } from './with-ui-components-styles';

export const UICardCVCElement = withUIComponentsStyles(CardCVCElement);
export const UICardElement = withUIComponentsStyles(CardElement);
export const UICardExpiryElement = withUIComponentsStyles(CardExpiryElement);
export const UICardNumberElement = withUIComponentsStyles(CardNumberElement);
export const UIIdealBankElement = withUIComponentsStyles(IdealBankElement, StripeComponentInputType.select);
export const UIElements = Elements;
